export function hasHTML(text: string) {
  const htmlTagRe = /<[a-z][\s\S]*>/i
  return htmlTagRe.test(text)
}
